module.exports = __webpack_public_path__ + "img/jpeg.a6d39bd1.svg";